import { render, staticRenderFns } from "./addLituConfig.vue?vue&type=template&id=3d3e19f1&scoped=true&"
import script from "./addLituConfig.vue?vue&type=script&lang=js&"
export * from "./addLituConfig.vue?vue&type=script&lang=js&"
import style0 from "./addLituConfig.vue?vue&type=style&index=0&id=3d3e19f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e19f1",
  null
  
)

export default component.exports